import { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";

import { formatEstado, formatEstados, formatModels, formatProvider } from "../../../utils/estados";

import { SelectSearch } from "../../../components";

import { changeUser, changeRole, groupedPermissions } from "../handlers";

import { changeUserRole, getPermissionsForm } from "./handlers";
import CardAdmin from "../CardAdmin";
import AddUsers from "../AddUser";

const UserRoleForm = ({ stateContext, dataContext, show }) => {
  const { state, setState } = stateContext;
  const { loading, role, user } = state;

  const { data, setData } = dataContext;
  const { users, roles, permissions } = data;
  const [showBuscar, setShowBuscar] = useState(false);
  const [permissionsForm, setPermissionsForm] = useState(null);

  useEffect(() => {
    setPermissionsForm(getPermissionsForm(permissions, role));
  }, [state, data]);

  const permissions_groups = groupedPermissions(permissionsForm);

  const grupos = permissions_groups && Object.keys(permissions_groups);

  const handleUserSelect = (selectedUser) => {

    // Buscar el usuario en users->persona->usuarioID
    const foundUser = users.find((user) => {
      // Verificar si user.persona existe y no es null
      if (user.persona && user.persona.usuarioID) {
        return user.persona.usuarioID === selectedUser.id;
      }
      return false; // Si persona es null o no tiene usuarioID, retornar false
    });


    // Si se encuentra el usuario, actualizar el estado con foundUser; de lo contrario, mantener selectedUser
    setState((prev) => ({ ...prev, user: foundUser ?? selectedUser }));
    setShowBuscar(false);
  };
  if (!show) return null;

  return (
    <>
      <AddUsers
        showBuscar={showBuscar}
        setShowBuscar={setShowBuscar}
        handleUserSelect={handleUserSelect}
      />
      <div className="row m-0">
        <SelectSearch
          className={{
            container: "col-12 col-lg-5",
            label: `form-label`,
          }}
          isClearable
          id="user"
          value={formatProvider(user)}
          onChange={(u) => changeUser(u, users, setState)}
          disabled={loading}
          label="Seleccione un Usuario *"
          options={formatModels(data.users)}
        />
        <SelectSearch
          className={{
            container: "col-12 col-lg-5",
            label: `form-label`,
          }}
          isClearable
          id="role"
          value={formatEstado(role)}
          onChange={(u) => changeRole(u, roles, setState)}
          disabled={loading}
          label="Seleccione un Rol *"
          options={formatEstados(data.roles)}
        />
        <div className="col-12 col-lg-2 m-auto d-flex flex-column">
          <label className={`invisible form-label`}>HIDDEN</label>

          <Spinner className="mx-auto" hidden={!loading} />

          {!user?.roles?.some((r) => r.id === role?.id) && (
            <button
              hidden={loading}
              className="btn btn-primary btn-md"
              disabled={!user || !role}
              onClick={() => changeUserRole(user, role, setState, setData, "add_user_role")}
            >
              AGREGAR
            </button>
          )}

          {user?.roles?.some((r) => r.id === role?.id) && (
            <button
              hidden={loading}
              className="btn btn-danger"
              disabled={!user || !role}
              onClick={() => changeUserRole(user, role, setState, setData, "remove_user_role")}
            >
              RETIRAR
            </button>
          )}
        </div>
      </div>

      <hr className="my-3" />

      {!!user?.roles?.length && (
        <>
          {user.roles.map((r) => (
            <span
              key={r.id}
              role="button"
              className={`me-2 badge bg-success ${r.id === role?.id ? "disabled" : ""}`}
              onClick={() => !loading && setState((state) => ({ ...state, role: r }))}
            >
              {r.description}
            </span>
          ))}
          <hr className="my-3" />
        </>
      )}

      {!!role && (
        <>
          <span>
            Configuración de <b> {role?.description}</b>{" "}
          </span>
          <hr />
        </>
      )}

      <CardAdmin
        grupos={grupos}
        permissions_groups={permissions_groups}
        role={role}
        loading={loading}
        changeCheckPermission={null}
        permissionsForm={permissionsForm}
        setPermissionsForm={setPermissionsForm}
      />
    </>
  );
};

export default UserRoleForm;
